import { useCallback } from 'react'

import { useSegment } from '../../../../../hooks'
import { useCustomerForm } from '../contexts/customerFormContext'

export const useTrackCustomerModal = () => {
  const { track } = useSegment()
  const { customerForm } = useCustomerForm()
  const { watch } = customerForm
  const customerType = watch('customerType')

  const trackCustomerModal = useCallback(
    (eventDetail: string, payload?: Record<string, any>) => {
      track(`XXX - Invoicing Core - Customer modal - ${eventDetail}`, {
        ...payload,
        customerType,
      })
    },
    [customerType, track],
  )

  return { trackCustomerModal }
}
